import { Link } from "react-router-dom";
import { Button } from "@/components/ui/Button";
import { LoadingScreen } from "@/components/LoadingScreen";
import { SafeImage } from "@/components/ui/SafeImage";
import { useCurrentUser } from "@/features/auth/hooks";
import { useSiteSettings } from "@/features/site-settings/hooks";

export function MaintenanceGate({ children }: { children: React.ReactNode }) {
  const siteSettings = useSiteSettings();
  const currentUser = useCurrentUser();
  const settings = siteSettings.data;
  const role = currentUser.data?.role;
  const canPreview =
    settings?.maintenanceMode &&
    ((role === "DEVELOPER" && settings.maintenanceAllowDeveloperPreview) ||
      (role === "OWNER" && settings.maintenanceAllowOwnerPreview));

  if (siteSettings.isLoading) return <LoadingScreen />;
  if (!settings?.maintenanceMode || canPreview) return <>{children}</>;

  return (
    <main className="grid min-h-screen place-items-center bg-black px-6 text-white">
      <section className="w-full max-w-2xl rounded-lg border border-cyan-300/25 bg-black/70 p-8 text-center shadow-neon">
        {settings.logoUrl ? (
          <SafeImage src={settings.logoUrl} alt={`${settings.siteName} logo`} fallbackLabel={settings.siteName.slice(0, 2)} className="mx-auto mb-6 h-24 object-contain" />
        ) : null}
        <p className="text-sm font-semibold uppercase tracking-[0.28em] text-teal-200">Maintenance Mode</p>
        <h1 className="mt-3 font-display text-4xl font-bold uppercase">{settings.siteName}</h1>
        <p className="mt-5 text-content-secondary">
          {settings.maintenanceMessage || "The site is temporarily offline for maintenance."}
        </p>
        {settings.maintenanceEstimatedReturn ? (
          <p className="mt-3 text-sm text-cyan-100">Estimated return: {settings.maintenanceEstimatedReturn}</p>
        ) : null}
        <Button asChild className="mt-8" variant="secondary">
          <Link to="/admin/login">Admin Login</Link>
        </Button>
      </section>
    </main>
  );
}
